(() => {
  if (customElements.get('pinus-sticky-cart')) return;

  class PinusStickyCart extends HTMLElement {
    connectedCallback() {
      this.source = document.getElementById(`ProductInfo-${this.dataset.sectionId}`);
      const template = this.querySelector('template');
      if (!this.source || !template) return;
      this.panel = template.content.firstElementChild.cloneNode(true);
      // A body-level panel remains fixed even inside animated theme sections.
      document.body.append(this.panel);
      this.submit = this.panel.querySelector('[data-sticky-submit]');
      this.label = this.panel.querySelector('[data-sticky-button-label]');
      this.price = this.panel.querySelector('[data-sticky-price]');
      this.selection = this.panel.querySelector('[data-sticky-selection]');
      this.savings = this.panel.querySelector('[data-sticky-savings]');
      this.error = this.panel.querySelector('[data-sticky-error]');
      this.submit.addEventListener('click', () => {
        this.sync();
        if (!this.nativeButton || this.submit.disabled) return;
        // Use the original click/submit pipeline, including Kaching gifts and discounts.
        this.nativeButton.click();
        this.sync();
      });
      this.visibility = new IntersectionObserver((entries) => {
        const entry = entries.find((item) => item.target === this.nativeButton);
        if (entry) this.setVisible(!entry.isIntersecting);
      });
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.sync();
        });
      };
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(this.source, {
        subtree: true, childList: true, characterData: true, attributes: true,
        attributeFilter: ['class', 'disabled', 'aria-disabled', 'hidden']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.visibility?.disconnect();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.panel?.remove();
      this.nativeButton = null;
      this.frame = null;
    }

    setVisible(visible) {
      if (!this.nativeButton) visible = false;
      if (!visible && this.panel.contains(document.activeElement)) {
        this.nativeButton?.focus({ preventScroll: true });
      }
      this.panel.hidden = !visible;
    }

    setText(element, value) {
      if (element.textContent !== value) element.textContent = value;
    }

    sync() {
      const nativeButton = this.source.querySelector(`#ProductSubmitButton-${CSS.escape(this.dataset.sectionId)}`);
      if (nativeButton !== this.nativeButton) {
        this.visibility.disconnect();
        this.nativeButton = nativeButton;
        this.panel.hidden = true;
        if (nativeButton) this.visibility.observe(nativeButton);
      }
      if (!nativeButton) return;
      const busy = nativeButton.classList.contains('loading');
      this.submit.disabled = nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true' || busy;
      this.submit.setAttribute('aria-busy', String(busy));
      if (nativeButton.hasAttribute('aria-haspopup')) {
        this.submit.setAttribute('aria-haspopup', nativeButton.getAttribute('aria-haspopup'));
      }
      this.setText(this.label, nativeButton.querySelector('span')?.textContent.trim() || nativeButton.textContent.trim());
      const bundleTotal = this.source.querySelector('[data-bundle-total]:not([hidden])');
      const nativePrice = this.source.querySelector('[id^="price-"] .price');
      const amount = bundleTotal?.querySelector('[data-bundle-current]') || nativePrice?.querySelector(
        nativePrice.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular'
      );
      this.setText(this.price, amount?.textContent.trim() || '');
      const bar = this.source.querySelector('.kaching-bundles__bar--selected');
      this.setText(this.selection, bar?.querySelector('.kaching-bundles__bar-title')?.textContent.trim() || '');
      const saved = bundleTotal?.querySelector('[data-bundle-savings]:not([hidden])');
      this.setText(this.savings, saved?.textContent.trim() || '');
      this.savings.hidden = !saved;
      const error = this.source.querySelector('.product-form__error-message-wrapper:not([hidden]) .product-form__error-message');
      const message = error?.textContent.trim() || '';
      this.setText(this.error, message);
      this.error.hidden = !message;
    }
  }

  customElements.define('pinus-sticky-cart', PinusStickyCart);
})();
